import {required,numeric} from "vuelidate/lib/validators";   
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import moment from 'moment' 
const StrKontrolStandart = {
  mixins: [Api, Sabit],
    data() {
      return {  
        StrRiskData:{ 
          SiraNo:0,
          Risk:"",
          Aciklama:"",
          Sebepler:"",
          Riskno:"",
          Risknokodlu:"",
          Hedef:"",
          Donemid:"",
          Amacid:"", 
          Deleted: false,
          Turid: "",
          Kaynakid: "",
          Riskpuanid:"",
          Risktipi:"",
          Created: ""
        },
        FormDataType:{ 
          SiraNo:{FieldName:"SiraNo",Field:"input",FieldTitle:this.$t('StrPerfTablo.AddEdit.SiraNo'),FieldType:"number"},
          Donemid:{FieldName:"Donemid",Field:"combobox",FieldTitle:this.$t('StrRisk.AddEdit.Donemid'),ComboDataArray:[]},
          Amacid:{FieldName:"Amacid",Field:"combobox",FieldTitle:this.$t('StrRisk.AddEdit.Amacid'),ComboDataArray:[]}, 
          Turid:{FieldName:"Turid",Field:"combobox",FieldTitle:this.$t('StrRisk.AddEdit.Turid'),ComboDataArray:[]}, 
          Kaynakid:{FieldName:"Kaynakid",Field:"combobox",FieldTitle:this.$t('StrRisk.AddEdit.Kaynakid'),ComboDataArray:[]}, 
          Riskpuanid:{FieldName:"Riskpuanid",Field:"combobox",FieldTitle:this.$t('StrRisk.AddEdit.Riskpuanid'),ComboDataArray:[]}, 
          Riskno:{FieldName:"Riskno",Field:"input",FieldTitle:this.$t('StrRisk.AddEdit.Riskno')},
          Risknokodlu:{FieldName:"Risknokodlu",Field:"input",FieldTitle:this.$t('StrRisk.AddEdit.Risknokodlu'),FieldType:"text"}, 
          Risk:{FieldName:"Risk",Field:"textarea",FieldTitle:this.$t('StrRisk.AddEdit.Risk')},
          Sebepler:{FieldName:"Sebepler",Field:"textarea",FieldTitle:this.$t('StrRisk.AddEdit.Sebepler')},
          Hedef:{FieldName:"Hedef",Field:"textarea",FieldTitle:this.$t('StrRisk.AddEdit.Hedef')},
          Aciklama:{FieldName:"Aciklama",Field:"textarea",FieldTitle:this.$t('StrRisk.AddEdit.Aciklama')},
          Risktipi:{FieldName:"Risktipi",Field:"combobox",FieldTitle:this.$t('StrRisk.AddEdit.Risktipi'),ComboDataArray:[]},
        },
        Tarih: moment(new Date()).format('YYYY-MM-DD'),

        Risk_Tipleri:[
          {Id:"1",Value:"Kurumsal Riskler"},
          {Id:"2",Value:"Operasyonel Riskler"},
        ]

        
      }
    },
    validations:{ 
      FormData: {
        SiraNo:{},
        Risk: { required }, 
        Aciklama: { required }, 
        Sebepler: { required },  
        Riskno: { required,numeric }, 
        Risknokodlu: { required }, 
        Hedef: { required }, 
        Donemid: { required },
        Amacid: { required },
        Turid: {  } ,
        Kaynakid:{  } ,
        Riskpuanid:{  },
        Risktipi:{required},
        Created: { }
      } 
  },
  created(){ 
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }


    let sorgu = "&Tip=1561";
    let Tip=[];
      
      this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
        console.log(res)
          for(var i=0; i<res.Data.length; i++)
          {   
              if(res.Data[i].Kod==5) { 

                  Tip.push(res.Data[i].Id);       

              } 
             
          }

          let altsorgu="&UstIdDoluMu=false&Approval=true";

          let tipler="";

          for (var s=0; s<Tip.length; s++){

              tipler=tipler+"&TipId="+Tip[s];

          }

          altsorgu=altsorgu+tipler;


          this.ActionsFilterGet({"Service":"StrPerfDonem","Page":Page,Filter:altsorgu}).then(res => {  
            for(var i=0; i<res.Data.length; i++)
              {
                if(this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= this.Tarih && this.Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)){
                  if(!res.Data[i].UstId){
                      this.FormDataType.Donemid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
                  }
                }
              }    
          }); 

        });


/*
    this.ActionsGet({"Service":"StrStratejikAmac","Page":Page}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Amacid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
        }    
    }); */

    this.ActionsGet({"Service":"StrRiskPuanlar","Page":Page}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          if(res.Data[i].Ustid==null || res.Data[i].Ustid=="" ){
          this.FormDataType.Riskpuanid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Kategorisi})
          }
        }    
    }); 
    this.ActionsGet({"Service":"OBirim","Page":Page}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Birimid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].BirimAdi})
        }    
    }); 

    let Filter = "&Tip=260";
            
    this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
        for(var i=0; i<res.Data.length; i++)
        {           
            this.FormDataType.Turid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})   
        }
 
    });

    let Filter2 = "&Tip=259";
            
    this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter2}).then((res) => {
        for(var i=0; i<res.Data.length; i++)
        {           
            this.FormDataType.Kaynakid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})   
        }
 
    });


    for(var i=0; i<this.Risk_Tipleri.length; i++)
    {           
        this.FormDataType.Risktipi.ComboDataArray.push ({Id:this.Risk_Tipleri[i].Id,Value:this.Risk_Tipleri[i].Value})   
    }


    
  }
}
export default StrKontrolStandart